import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'
import { parseJwt } from '../functions/util'
import { usePluginspace } from '../hooks/usePluginspace';
import { useNavigate, useParams } from 'react-router-dom';
import { PluginspaceResponseType } from './PluginspaceContext';
export type DecodedTokenData = {
    id: number;
    email: string;
    plugintype: string;
    identifier: string;
    pluginspaceId: number;
    plugintypeId: string;
    profile: string;
    pluginAdm: number;
    expiratedAt: string;
}

type LoginData = {
    accessToken: string
    id?: string | number
    expiratedAt: string
    identifier: string
    email: string
    plugintype: string
    pluginspaceId: number | null
    plugintypeId: string;
    profile: string;
}

type AuthContextData = {
    loginInfo: LoginData
    setLoginInfo: Dispatch<SetStateAction<LoginData>>;
    logout: () => void;
    verifyPluginSpace: () => boolean;
    getInitialData: () => Promise<DecodedTokenData | undefined>;
}



type AuthContextProvider = {
    children: ReactNode
}


export const AuthContext = createContext({} as AuthContextData)

const AuthProvider = ({ children }: AuthContextProvider) => {
    const { getThisPluginspace, pluginspaceData } = usePluginspace();
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const [loginInfo, setLoginInfo] = useState<LoginData>({
        accessToken: '',
        expiratedAt: '',
        identifier: '',
        id: '',
        email: '',
        plugintype: '',
        pluginspaceId: null,
        plugintypeId: '',
        profile: '',
    })

    const logout = () => {

        localStorage.removeItem('loginInfo')
        setLoginInfo({
            accessToken: '',
            expiratedAt: '',
            identifier: '',
            email: '',
            plugintype: '',
            pluginspaceId: null,
            plugintypeId: '',
            profile: '',
        })

    }

    const getInitialData = async () => {
        try {
            let login = localStorage.getItem('loginInfo')
            const pluginspace = await getThisPluginspace()

            if (login && typeof login === 'string') {
                const data = JSON.parse(login)
                if (process.env.REACT_APP_JWT_SALT && data) {
                    const tkNoSalt = data.split(process.env.REACT_APP_JWT_SALT).join('');
                    const tk: DecodedTokenData | null = parseJwt(tkNoSalt);

                    if (tk && tk.pluginspaceId === pluginspace!.id) {
                        setLoginInfo({
                            accessToken: data,
                            expiratedAt: tk.expiratedAt,
                            id: tk.id,
                            identifier: tk.identifier,
                            email: tk.email,
                            plugintype: tk.plugintype,
                            pluginspaceId: tk.pluginspaceId,
                            plugintypeId: tk.plugintypeId,
                            profile: tk.profile,
                        })
                        return tk
                    } else {
                        logout()
                    }
                } else {
                    logout()
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const verifyToken = async () => {
        let login = localStorage.getItem('loginInfo_ninegrid_access')
        if (!login) login = localStorage.getItem('loginInfo_ninegrid_adm')
        if (login && typeof login === 'string') {
            const data: LoginData = JSON.parse(login)

            const isExpired =
                new Date(data.expiratedAt).getTime().toFixed(0) < new Date().getTime().toFixed(0)

            if (isExpired) {
                setLoginInfo({
                    accessToken: '',
                    expiratedAt: '',
                    identifier: '',
                    email: '',
                    plugintype: '',
                    pluginspaceId: null,
                    plugintypeId: '',
                    profile: '',
                })
                localStorage.removeItem('loginInfo')

            }
        }
    }

    const verifyPluginSpace = () => {
        const login = localStorage.getItem('loginInfo_ninegrid_adm');
        if (!login) return false
        const data: LoginData = JSON.parse(login)
        if (process.env.REACT_APP_JWT_SALT && data) {
            const tkNoSalt = data.accessToken.split(process.env.REACT_APP_JWT_SALT).join('');
            const tk: DecodedTokenData | null = parseJwt(tkNoSalt);
            if (tk?.pluginspaceId === 2) {
                return true;
            }
        }
        return false;
    }



    useEffect(() => {
        getInitialData()
    }, [])

    return (
        <AuthContext.Provider
            value={{
                loginInfo,
                setLoginInfo,
                logout,
                verifyPluginSpace,
                getInitialData
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider